import { useSettings } from "@/entities/settings";
import { formatPrice } from "@/shared/lib/format";

export function useFormatPrice(): (n: number) => string {
  const { get } = useSettings();
  const symbol = String(get("currency_symbol") ?? "\u20BD");
  return (n: number) => formatPrice(n, symbol);
}
